import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Data } from '../../models/data';
import { Tariff } from '../../models/tariff';
import { Tariffreturndo } from '../../models/tariffreturndo';
import { Response } from '../../models/response';
import { Routing } from '../../models/routing';
import { Connote } from '../../models/connote';
import { Status } from '../../models/status';
import { Ticket } from '../../models/ticket';
import { Area } from '../../models/area';
import { Oda } from '../../models/oda';
import { Posm } from '../../models/posm';
import { Transaction } from '../../models/transaction';
import { Preacceptance } from '../../models/preacceptance';
import { Pl9 } from '../../models/pl9';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  /*prod path*/
  basepath = 'https://api.dexasia.com.my';

  //dev path
 //basepath = 'http://api.dexasia.com.my';

  //local path
  //basepath = 'http://localhost/fusiolocal';


  //basepath = 'http://api.foxnuvem.com.my';
  loginpath = this.basepath + '/login';
  registerpath = this.basepath + '/register';
  authpath = this.basepath + '/rest';

  //prod path 
  paypath = 'https://dexmart.com.my/index.php?route=checkout/add_dexpay';
  walletpath = 'https://dexmart.com.my/index.php?route=extension/payment/wkwallet/confirm2';
  posmpath = 'https://dexmart.com.my/index.php?route=checkout/posm_api';
  nwpath = 'https://dexmart.com.my/index.php?route=checkout/nw_api';
  eticketpath = 'https://api.dexasia.com.my/ETicketing/Service';      
  
  //upload-acc
 // private phpUrl  = 'https://accounting.dexasia.com.my/upload.php'; // Adjust the URL to your PHP file

  //end

  //paypath = 'http://mart.foxnuvem.com.my/index.php?route=checkout/add_dexpay';
  //walletpath = 'http://mart.foxnuvem.com.my/index.php?route=extension/payment/wkwallet/confirm2';

  //dev path
  /*paypath = 'http://koponas02.dexasia.com.my/index.php?route=checkout/add_dexpay';
  walletpath = 'http://koponas02.dexasia.com.my/index.php?route=extension/payment/wkwallet/confirm2';
  posmpath = 'http://koponas02.dexasia.com.my/index.php?route=checkout/posm_api';
  nwpath = 'http://koponas02.dexasia.com.my/index.php?route=checkout/nw_api';
  eticketpath = 'http://api.dexasia.com.my/ETicketing/Service';*/        


   //local path
   /*paypath = 'http://localhost/dex02/index.php?route=checkout/add_dexpay';
   walletpath = 'http://localhost/dex02/index.php?route=extension/payment/wkwallet/confirm2';
   posmpath = 'http://localhost/dex02/index.php?route=checkout/posm_api';
   nwpath = 'http://localhost/dex02/index.php?route=checkout/nw_api';*/



  constructor(private http: HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  httpOptions1 = {};


  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.log(error);
      console.error(
        /*`Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);*/  
        `${error.error}`
      );
    }
    return throwError(
      'Something bad happened; please try again later.');
  }

  postData(item): Observable<Response> {
    console.log(JSON.stringify(item));
    return this.http
      .post<Response>(this.authpath, JSON.stringify(item), this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  //eticket start
  eticketGetFrom(): Observable<Ticket> {
    var formData = new FormData();
    formData.append("action","GetFrom");

  //log1
  //
  console.log('fairuz');
  console.log('GetFrom = ');
  console.log(formData);

    return this.http
      .post<Ticket>(this.eticketpath, formData)
      .pipe(
        catchError(this.handleError)
      );
  }

  eticketGetTo(id): Observable<Ticket> {
    var formData = new FormData();
    formData.append("action","GetTo");
    formData.append("fromId", id);

    //log2
    console.log('GetToId = ' + id);

    return this.http
      .post<Ticket>(this.eticketpath, formData)
      .pipe(
        catchError(this.handleError)
      );
  }


  
  eticketGetCompanies(from, to): Observable<Ticket> {
    var formData = new FormData();
    formData.append("action","GetCompanies");
    formData.append("fromId", from);
    formData.append("toId", to);

    //log3
    console.log('GetCompaniesFrom = ' + from + ' GetCompaniesTo = ' + to);


    return this.http
      .post<Ticket>(this.eticketpath, formData)
      .pipe(
        catchError(this.handleError)
      );
  }


  eticketGetTrips(from, to, dDate, rDate): Observable<Ticket> {

    var formData = new FormData();
    formData.append("action","GetTrips");
    formData.append("fromId", from);
    formData.append("toId", to);
    formData.append("departDate", dDate);
    if (rDate != null) formData.append("returnDate", rDate);
    // formData.append("companyId", id);

    //log4
    console.log('GetTripsFromId = ' + from + ',' + 'GetTripsToId = ' + to + ',' + 'GetTripsDepartDate = ' + dDate + ',' + 'GetTripsReturnDate = ' + rDate);

    return this.http
      .post<Ticket>(this.eticketpath, formData)
      .pipe(
        catchError(this.handleError)
      );

      console.log
  }

  eticketGetBus(from, to, dDate, rDate, dId, rId): Observable<Ticket> {

    var formData = new FormData();
    formData.append("action","GetBus");
    formData.append("fromId", from);
    formData.append("toId", to);
    formData.append("departDate", dDate);
    if (rDate != null) formData.append("returnDate", rDate);
    formData.append("departTripId", dId);
    if (rId != null) formData.append("returnTripId", rId);
    else formData.append("returnTripId", "0");

    //log5
    console.log('GetBus = ' + from + ',' + 'GetTripsToId = ' + to + ',' + 'GetTripsDepartDate = ' + dDate + ',' + 'GetTripsReturnDate = ' + rDate + ',' + 'GetBusDepartTripId =' + dId + ','  + 'GetBusReturnTripId' + rId);


    return this.http
      .post<Ticket>(this.eticketpath, formData)
      .pipe(
        catchError(this.handleError)
      );
  }

  eticketConfirmSeat(from, to, dDate, rDate, dId, rId, pContact, pDepart, pReturn): Observable<Ticket> {

    var formData = new FormData();
    formData.append("action","ConfirmSeat");
    formData.append("fromId", from);
    formData.append("toId", to);
    formData.append("departDate", dDate);
    if (rDate != null) formData.append("returnDate", rDate);
    formData.append("departTripId", dId);
    if (rId != null) formData.append("returnTripId", rId);
    else formData.append("returnTripId", "0");
    formData.append("personContact", JSON.stringify(pContact));
    formData.append("personDepart", JSON.stringify(pDepart));
    if (pReturn != null) formData.append("personReturn", JSON.stringify(pReturn));

    //log6
    console.log('ConfirmSeatFromId = ' + from + ',' + 'ConfirmSeatToId = ' + to + ',' + 'ConfirmSeatDepartDate = ' + dDate + ','  + 'ConfirmSeatReturnDate = ' + rDate + ',' + 'ConfirmSeatDepartTripId =' + dId + ','  + 'ConfirmSeatReturnTripId' + rId + ',' + 'PersonContact = ' + JSON.stringify(pContact) + ',' + 'PersonContactDepart = ' + JSON.stringify(pDepart) + ',' + 'PersonContactReturn' + JSON.stringify(pReturn) );

    return this.http
      .post<Ticket>(this.eticketpath, formData)
      .pipe(
        catchError(this.handleError)
      );
  }


  //end


  postDataTransaction(item): Observable<Transaction[]> {
    return this.http
      .post<Transaction[]>(this.authpath, JSON.stringify(item), this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  pay(item): Observable<Response> {
    return this.http
      .post<Response>(this.paypath, JSON.stringify(item), this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  posm(item): Observable<Routing> {
    return this.http
      .post<Routing>(this.posmpath, JSON.stringify(item), this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  tariff(item): Observable<Tariff> {
    return this.http
      .post<Tariff>(this.posmpath, JSON.stringify(item), this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  nwtariff(item): Observable<Tariff> {
    return this.http
      .post<Tariff>(this.nwpath, JSON.stringify(item), this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  nwarea(item): Observable<Area> {
    return this.http
      .post<Area>(this.nwpath, JSON.stringify(item), this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  nwoda(item): Observable<Oda> {
    return this.http
      .post<Oda>(this.nwpath, JSON.stringify(item), this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

    //nw return do
    nwtariffreturndo(item): Observable<Tariffreturndo> {
      return this.http
        .post<Tariffreturndo>(this.nwpath, JSON.stringify(item), this.httpOptions)
        .pipe(
          catchError(this.handleError)
        );
    }
    //end

  connote(item): Observable<Connote> {
    return this.http
      .post<Connote>(this.posmpath, JSON.stringify(item), this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  pos(item): Observable<Posm> {
    return this.http
      .post<Posm>(this.posmpath, JSON.stringify(item), this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  nw(item): Observable<Posm> {
    return this.http
      .post<Posm>(this.nwpath, JSON.stringify(item), this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  pl9(item): Observable<Pl9> {
    return this.http
      .post<Pl9>(this.posmpath, JSON.stringify(item), this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  status(item): Observable<Status> {
    return this.http
      .post<Status>(this.posmpath, JSON.stringify(item), this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  preacceptance(item): Observable<Preacceptance> {
    return this.http
      .post<Preacceptance>(this.posmpath, JSON.stringify(item), this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  wallet(item): Observable<Response> {
    return this.http
      .post<Response>(this.walletpath, JSON.stringify(item), this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  login(item): Observable<Response> {
    return this.http
      .post<Response>(this.loginpath, JSON.stringify(item), this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  register(item): Observable<Response> {
    return this.http
      .post<Response>(this.registerpath, JSON.stringify(item), this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getData(): Observable<Response> {
    return this.http
      .get<Response>(this.authpath, this.httpOptions)
      .pipe(
        catchError(this.handleError)
      );
  }

  getIP(): Observable<any> {
    return this.http
      .get<any>("http://api.ipify.org/?format=json")
      .pipe(
        catchError(this.handleError)
      );
  }

  //upload
  callPhpScript(): Observable<any> 
  {
    return this.http.get('https://accounting.dexasia.com.my/upload.php');
    // Or for POST requests:
    // return this.http.post('http://your-domain.com/path/to/your-php-file.php', { key: 'value' });
  }
  //end



}
